import React from "react";

export default function Services() {
  const services = [
    { 
      title: "Domestic Shipping", 
      desc: "Fast & secure nationwide parcel delivery for individuals & businesses.",
      icon: "bi-truck"
    },
    { 
      title: "International Shipping", 
      desc: "Worldwide freight forwarding via air & sea with customs support.",
      icon: "bi-globe2"
    },
    { 
      title: "Warehousing", 
      desc: "Smart inventory management, storage & real-time stock insights.",
      icon: "bi-house-door"
    },
    { 
      title: "E-commerce Fulfillment", 
      desc: "Picking, packing & order delivery solutions for online sellers.",
      icon: "bi-bag-check"
    },
    { 
      title: "Customs Clearance", 
      desc: "Import/export documentation, compliance & border clearance.",
      icon: "bi-file-earmark-text"
    },
    { 
      title: "Freight Management", 
      desc: "End-to-end cargo movement with real-time visibility.",
      icon: "bi-box-seam"
    }
  ];

  return (
    <>

      {/* ⭐ INLINE PREMIUM CSS */}
      <style>{`
        .services-section {
          padding: 80px 0;
          background: #f6f9ff;
        }

        .service-card {
          background: #fff;
          border-radius: 18px;
          padding: 35px 25px;
          text-align: center;
          border: 1px solid rgba(0,0,0,0.05);
          box-shadow: 0px 10px 25px rgba(0,0,0,0.07);
          transition: 0.35s ease;
          position: relative;
          overflow: hidden;
          opacity: 0;
          animation: fadeUp 0.9s forwards;
        }

        .service-card:hover {
          transform: translateY(-12px);
          border-color: #005eff;
          box-shadow: 0px 18px 35px rgba(0, 94, 255, 0.25);
        }

        /* Icon styling */
        .service-icon {
          font-size: 45px;
          color: #005eff;
          margin-bottom: 15px;
          transition: 0.3s ease;
        }

        .service-card:hover .service-icon {
          color: #f80b0b;
          transform: scale(1.15);
        }

        .service-title {
          font-weight: 700;
          font-size: 20px;
          margin-bottom: 12px;
        }

        .service-desc {
          font-size: 15px;
          color: #666;
          min-height: 65px;
        }

        .service-btn {
          margin-top: 15px;
          padding: 8px 18px;
          border-radius: 10px;
          font-size: 15px;
          transition: 0.3s;
        }

        .service-btn:hover {
          background: #f80b0b !important;
          transform: translateY(-3px);
          color: #fff;
          box-shadow: 0px 8px 20px rgba(248, 11, 11, 0.35);
        }

        /* Animation */
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ SERVICES SECTION */}
      <section className="services-section">
        <div className="container">

          <h2 className="fw-bold text-center mb-4 fadeUp" style={{ animationDelay: "0.1s" }}>
            Our Premium Services
          </h2>
          <p className="text-center text-muted mb-5 fadeUp" style={{ animationDelay: "0.2s" }}>
            Reliable, secure & scalable logistics solutions tailored for businesses of all sizes.
          </p>

          <div className="row g-4">
            {services.map((s, i) => (
              <div className="col-md-4" key={i}>
                <div className="service-card" style={{ animationDelay: `${0.3 + i * 0.15}s` }}>

                  <i className={`bi ${s.icon} service-icon`}></i>

                  <h5 className="service-title">{s.title}</h5>

                  <p className="service-desc">{s.desc}</p>

                  <button className="btn btn-primary service-btn">
                    Learn More →
                  </button>

                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}
